<template>
  <div class="enterPage flex-column">
    <div class="header">
      <i class="fa fa-angle-left" @click="back"></i>
      	入驻
    </div>
    <div class="body flex-column-1" v-show="infoPageIndex == 1">
      <ul class="infoContainer">
      	<div class="mask" v-if="reviewStatus!==0" @click.stop="isVerify"></div>
        <li class="infoItem">
          <span class="title">物流公司全称</span>
          <input type="text" class="inputVal" v-model="baseInfo.name" placeholder="请填写">
        </li>
        <li class="infoItem">
          <span class="title">所在园区</span>
          <input @click="showLog=true" type="text" readonly="readonly" class="inputVal" v-model="baseInfo.logisticsName" placeholder="请选择所在园区">
        </li>
        <li class="infoItem">
          <span class="title">联系人</span>
          <input type="text" class="inputVal" v-model="baseInfo.contactUsername" placeholder="请填写">
        </li>
        <li class="infoItem">
          <span class="title">联系电话</span>
          <input type="text" class="inputVal" v-model="baseInfo.contactPhone" placeholder="请填写">
        </li>
        <li class="infoItem">
          <span class="title">公司地址</span>
          <input type="text" class="inputVal" v-model="baseInfo.companyAddress" placeholder="请填写">
        </li>
        <li class="infoItem">
          <span class="title">公司物流标签</span>
          <input type="text" class="inputVal" readonly="readonly" v-model="baseInfo.logisticCompanyLabel" placeholder="请选择(可多选)">

          <div class="tagsSelector">
            <ul>
              <li
                v-for="item in tags"
                :key="item"
                :class="{selected: baseInfo.logisticCompanyLabel.includes(item)}"
                @click="selectTag(item)"
              >{{item}}</li>
              <li @click="addTag">
                <i class="icon iconfont icon-add" style="font-size:6px;"></i>
                新增
              </li>
            </ul>
          </div>
        </li>
        <li class="infoItem">
          <span class="title">请上传相关证件</span>
          <div class="uploadImgBox">
            <uploadImg @loaded="baseInfo.companyImgUrl1 = $event.base64" :showImg="true" :base64="baseInfo.companyImgUrl1">
              <div class="center">
                <img :src="require('@/assets/imgs/icons/addImg.png')" alt>
                <p class="title">公司轮播图</p>
                <!--<p class="note">(可多张)</p>-->
              </div>
            </uploadImg>
            <uploadImg @loaded="baseInfo.logisticCompanyLogo = $event.base64" :showImg="true" :base64="baseInfo.logisticCompanyLogo">
              <div class="center">
                <img :src="require('@/assets/imgs/icons/addImg.png')" alt>
                <p class="title">公司logo图</p>
              </div>
            </uploadImg>
          </div>
        </li>
      </ul>
      <div class="line-box"></div>
			<transition name="fade"  v-for="(item,index) in netInfo" :key="index">
	      <ul class="infoContainer">
	      	<div class="mask" v-if="reviewStatus!==0" @click.stop="isVerify"></div>
	        <h5 class="bigTitle">公司网点{{index+1}}<button v-if="!item.id" @click="deleteBtn(index)">删除</button></h5>
	        <li class="infoItem">
	          <span class="title">网点名称</span>
	          <input type="text" class="inputVal" v-model="item.nodeName" placeholder="请填写(如:北京市)">
	        </li>
	        <li class="infoItem" @click="showPickCityBtn(index)">
	          <span class="title">城市</span>
	          <input type="text" class="inputVal" readonly="readonly" v-model="item.cityAll" placeholder="请选择城市">
	        </li>
	        <li class="infoItem">
	          <span class="title">联系人</span>
	          <input type="text" class="inputVal" v-model="item.nodeDutyOfficer" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">联系电话</span>
	          <input type="text" class="inputVal" v-model="item.chargerPhone" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">网点地址</span>
	          <input type="text" class="inputVal" v-model="item.nodeAddress" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">辐射网点</span>
	          <input type="text" class="inputVal" v-model="item.radiationNodeName" placeholder="请填写">
	        </li>
	      </ul>
			</transition>
      <div class="addNetBt" @click="addNet" v-if="reviewStatus==0">
        <i class="icon iconfont icon-add"></i>
        新增网点
      </div>
    </div>

    <div class="nextStep" v-show="infoPageIndex == 1" @click="infoPageIndexBtn">下一步</div>

    <div class="body  flex-column-1" v-show="infoPageIndex == 2">
    	<transition name="fade" v-for="(item,index) in pathInfo" :key="index">
	      <ul class="infoContainer">
	      	<div class="mask" v-if="reviewStatus!==0" @click.stop="isVerify"></div>
	        <h5 class="bigTitle">公司路线{{index+1}}<button v-if="!item.id" @click="deleteRouteBtn(index)">删除</button></h5>
	        <li class="infoItem">
	          <span class="title">路线名称</span>
	          <input type="text" class="inputVal" v-model="item.lineName" placeholder="请填写(如:广州到北京)">
	        </li>
	        <li class="infoItem">
	          <span class="title">路线类型</span>
	          <!--<input type="text" class="inputVal" v-model="item.routeLineTypeId" placeholder="请填写">-->
	          	<font class="line-type" v-if="item.routeLineTypeId==6" @click="item.routeLineTypeId=3">直达</font>
	          	<font class="line-type" v-if="item.routeLineTypeId==3" @click="item.routeLineTypeId=6">中转</font>
	        </li>
	        <li class="infoItem" @click="CommonPick(index,'start')">
	          <span class="title">起始地</span>
	          <input type="text" class="inputVal" readonly="readonly" v-model="item.startOrganizationName" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">始发联系人</span>
	          <input type="text" class="inputVal" v-model="item.startContactUserName" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">始发联电话</span>
	          <input type="text" class="inputVal" v-model="item.startContactPhoneNo" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">始发网点地址</span>
	          <input type="text" class="inputVal" v-model="item.startNodeAddr" placeholder="请填写">
	        </li>
	        <li class="infoItem"  @click="CommonPick(index,'end')">
	          <span class="title">卸货地</span>
	          <input type="text" class="inputVal" readonly="readonly" v-model="item.destOrganizationName" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">卸货联系人</span>
	          <input type="text" class="inputVal" v-model="item.destContactUserName" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">卸货联系人电话</span>
	          <input type="text" class="inputVal" v-model="item.destContactPhoneNo" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">卸货网点地址</span>
	          <input type="text" class="inputVal" v-model="item.destNodeAddr" placeholder="请填写">
	        </li>
	        <li class="infoItem">
	          <span class="title">时效说明</span>
	          <input type="text" class="inputVal" v-model="item.timeLimitExplain" placeholder="请填写">
	        </li>
	      </ul>
      </transition>
      <div class="addNetBt" @click="addPath" v-if="reviewStatus==0">
        <i class="icon iconfont icon-add"></i>
        新增路线
      </div>
    </div>

    <div class="confirm" @click="success()" v-show="infoPageIndex == 2">完成</div>
    <transition name="fade">
			<pickLogistics v-if="showLog" @emitLogistics="getLogisticsInfo" @closePick="showLog=false"></pickLogistics>
		</transition>
		<transition name="fade">
			<cityPick @emitCity="emitCity" @closePick="showPickCity=false" v-if="showPickCity" :chooseArea="true"></cityPick>   
		</transition>
		<transition name="fade">
			<commonPick :pickParmas="pickParmas" @closeCommonPick="showCommonPick=false" @commonPick="commonPick" v-if="showCommonPick"></commonPick>
  	</transition>
  </div>
</template>
<script>
import { MessageBox,Toast } from "mint-ui"
import uploadImg from "@/components/function/uploadImg" //上传图片组件
import { ADD_COMPANY,SAVE_ORGANIZATION_LIST,GET_LOGISTIC_PARKS,GET_COMPANY_AND_ORGANIZATION_INFO,GET_COMPANY_TMP_ORANGIZATIONS,SAVE_ROUTE_LINE_LIST,GET_TMP_ROUTE_LINES } from "@/assets/configs/api/yuanqu"

export default {
  name: "enterPage",
  data() {
    return {
    	routeIndex:null,
    	routeIsStart:null,
    	showCommonPick:false,
    	netIndex:null,
    	showLog:false,
    	reviewStatus:0,
    	showPickCity:false,
    	pickParmas:{
    		url:GET_COMPANY_TMP_ORANGIZATIONS,
    		sonkeyValue:"nodeName",
    		companyId:""
    	},
      infoPageIndex: 1,
      baseInfo: {
      	id:"",
      	nodeType:"YYWD",
        name: "",
        logisticsName:"",
        parkCode:"",
        contactUsername: "",
        contactPhone: "",
        companyAddress: "",
        logisticCompanyLabel: [],
        companyImgUrl1:"",
        logisticCompanyLogo:""
      },
      netInfo: [],
      netInfoForm: {
      	id:"",
      	companyId:"",
      	appNodeName:"",
        nodeName: "",
        cityAll:"",
        nodeDutyOfficer: "",
        chargerPhone: "",
        nodeAddress: "",
        radiationNodeName: "",
        provinceName:"",
        cityName:"",
        areaName:""
      },
      pathInfo: [],
      pathInfoForm: {
      	id:"",
        lineName: "",
        routeLineTypeId: "6",
        startOrganizationId: "",
        startOrganizationName: "",
        startContactPhoneNo:"",
        startContactUserName: "",
        startNodeAddr: "",
        destOrganizationId: "",
        destOrganizationName: "",
        destContactPhoneNo:"",
        destContactUserName: "",
        destNodeAddr: "",
        timeLimitExplain: "",
        isReviewLine:-1,
        companyId:""
      },
      orgIds:[],
      tags: ["认证", "金牌", "往返", "甩挂", "三方", "专线", "仓储"]
    };
  },
  created() {

  },
  methods: {
  	isVerify () {
//			Toast("审核通过不允许修改")
  	},
  	CommonPick (index,isStart) {
  		this.routeIndex = index
  		this.routeIsStart = isStart
  		this.showCommonPick = true
  	},
  	commonPick (data) {
  		console.log(data)
  		this.showCommonPick = false
  		if(this.routeIsStart == "start"){
  			this.pathInfo[this.routeIndex].startOrganizationId = data.id
  			this.pathInfo[this.routeIndex].startOrganizationName = data.nodeName
  			this.pathInfo[this.routeIndex].startContactUserName = data.nodeOfficerName
  			this.pathInfo[this.routeIndex].startNodeAddr = data.nodeAddress
  			this.pathInfo[this.routeIndex].startContactPhoneNo = data.nodeOfficerPhone
  		}else if(this.routeIsStart == "end"){
  			this.pathInfo[this.routeIndex].destOrganizationId = data.id
  			this.pathInfo[this.routeIndex].destOrganizationName = data.nodeName
  			this.pathInfo[this.routeIndex].destContactUserName = data.nodeOfficerName
  			this.pathInfo[this.routeIndex].destNodeAddr = data.nodeAddress
  			this.pathInfo[this.routeIndex].destContactPhoneNo = data.nodeOfficerPhone
  		}
  	},
  	showPickCityBtn (index) {
  		this.netIndex = index
  		this.showPickCity = true
  	},
  	emitCity (data) {
  		this.showPickCity = false
  		this.netInfo[this.netIndex].cityAll = data.provinceText + data.cityText + data.areaText
  		this.netInfo[this.netIndex].provinceName = data.provinceText
  		this.netInfo[this.netIndex].cityName = data.cityText
  		this.netInfo[this.netIndex].areaName = data.areaText
  	},
  	deleteBtn (index) {
			let vm = this
			MessageBox.confirm('确定删除此网点?').then(action => {
			  vm.netInfo.splice(index, 1)
			},cancel => {
				
			})
  	},
  	deleteRouteBtn (index) {
  		let vm = this
  		MessageBox.confirm('确定删除此路线?').then(action => {
			  vm.pathInfo.splice(index, 1)
			},cancel => {
				
			})
  	},
  	infoPageIndexBtn(){
  		if(this.reviewStatus!==0){
  			this.infoPageIndex = 2;
  			return
  		}
  		let isCompanyComplete = true
  		try{
				if(this.baseInfo.name == ""){
					Toast("请输入物流公司全称")
					return
				}
				if(this.baseInfo.logisticsName == ""){
					Toast("请选择所在园区")
					return
				}
				if(this.baseInfo.contactUsername == ""){
					Toast("请输入联系人")
					return
				}
				var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.baseInfo.contactPhone)) {
						Toast("联系电话不符合规格")
            throw 'Jump out now!'
        }
				if(this.baseInfo.companyAddress == ""){
					Toast("请输入公司地址")
					return
				}
				if(!this.baseInfo.logisticCompanyLabel.join(",")){
					Toast("请选择公司物流标签")
					return
				}
				if(!this.baseInfo.companyImgUrl1){
					Toast("请上传公司轮播图")
					return
				}
				if(!this.baseInfo.logisticCompanyLogo){
					Toast("请选择公司logo图")
					return
				}
			}catch (e) {
  			isCompanyComplete = false
  		}
			if(isCompanyComplete){
				this.$post(ADD_COMPANY,
					{
						id:this.baseInfo.id,
						logisticCompanyFullName:this.baseInfo.name,
						logistiCompanyName:this.baseInfo.name,
						parkCode:this.baseInfo.parkCode,
						contactUsername:this.baseInfo.contactUsername,
						contactPhone:this.baseInfo.contactPhone,
						companyAddress:this.baseInfo.companyAddress,
						logisticCompanyLabel:this.baseInfo.logisticCompanyLabel.join(","),
						companyImgUrl1:this.baseInfo.companyImgUrl1,
						logisticCompanyLogo:this.baseInfo.logisticCompanyLogo
					},
					data => {
						if(!this.netInfo.join(",")){
							Toast("入驻成功")
			  			history.go(-1)
			  	}else{
			  			this.pickParmas.companyId = data.companyId
			  			this.pathInfoForm.companyId = data.companyId
			  			this.saveOrganizationList(data.companyId)
			  		}
					},
	        error => {
	        	Toast(error)
	        }
	      )
			}
  	},
  	saveOrganizationList (companyId) {
  		let isComplete = true
  		try{
  			this.netInfo.forEach( (item,index) => {
	  			item.companyId = companyId
	  			item.appNodeName = item.nodeName
	  			if(item.nodeName == ""){
	  				Toast(`请输入公司网点${index+1}网点名称`)
	  				throw 'Jump out now!'
	  			}
	  			if(item.cityAll == ""){
	  				Toast(`请选择公司网点${index+1}城市`)
	  				throw 'Jump out now!'
	  			}
	  			if(item.nodeDutyOfficer == ""){
	  				Toast(`请输入公司网点${index+1}联系人`)
	  				throw 'Jump out now!'
	  			}
	  			var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
	        if (!myreg.test(item.chargerPhone)) {
							Toast(`请输入公司网点${index+1}号码不符合规格`)
	            throw 'Jump out now!'
	        }
	  			if(item.nodeAddress == ""){
	  				Toast(`请输入公司网点${index+1}网点地址`)
	  				throw 'Jump out now!'
	  			}
	  			if(item.radiationNodeName == ""){
	  				Toast(`请输入公司网点${index+1}辐射网点`)
	  				throw 'Jump out now!'
	  			}
	  		})
  		}catch (e) {
  			isComplete = false
  		}
  		if(isComplete){
				let config = {
					headers: {
						"Content-Type": "application/json"
					}
				}
				this.$post(SAVE_ORGANIZATION_LIST,
					this.netInfo,
					data => {
						this.orgIds = data
						this.getTmpRouteLines (this.baseInfo.id)
						this.infoPageIndex = 2
					},
	        error => {
	        	Toast(error)
	        },config
	      )
  		}
  	},
  	getLogisticsInfo (item) {
  		this.baseInfo.logisticsName = item.name
  		this.baseInfo.parkCode = item.code
  		this.showLog = false
  	},
    addNet() {
      this.netInfo.push(JSON.parse(JSON.stringify(this.netInfoForm)));
    },
    addPath() {
      this.pathInfo.push(JSON.parse(JSON.stringify(this.pathInfoForm)));
    },
    selectTag(val) {
      let tags = this.baseInfo.logisticCompanyLabel;
      if (tags.includes(val)) {
        tags.splice(tags.indexOf(val), 1);
      } else {
        this.baseInfo.logisticCompanyLabel.push(val);
      }
    },
    addTag() {
      MessageBox.prompt("请输入标签名").then(({ value }) => {
        if (value) {
          this.tags.push(value);
          this.baseInfo.logisticCompanyLabel.push(value);
        }
      });
    },
		back () {
			if(this.infoPageIndex === 2){
				this.initInfo ()
				this.infoPageIndex = 1
			}else{
				history.go(-1)
			}
		},
    success(){
    	if(this.reviewStatus !== 0){
  			history.go(-1)
  			return
  		}
    	if(!this.pathInfo.join(",")){
				history.go(-1)
			}else{
				let config = {
	  			headers: {
	  				"Content-Type": "application/json"
	  			}
	  		}
				this.$post(SAVE_ROUTE_LINE_LIST,
					this.pathInfo,
					data => {
						Toast("保存成功")
						history.go(-1)
					},
	        error => {
	        	Toast(error)
	        },config
	      )
			}
    },
    //初始化页面
    initInfo () {
    	this.$post(GET_COMPANY_AND_ORGANIZATION_INFO,
				{
					
				},
				data => {
					if(data.error){
						console.log(data.error)
					}
					if(data.companyInfo){
						this.reviewStatus = data.companyInfo.reviewStatus
						//有注册公司的才调接口找路线
						if(data.companyInfo.id){
							this.getTmpRouteLines(data.companyInfo.id)
						}
						//初始化公司资料信息
						this.baseInfo.id = data.companyInfo.id
						this.baseInfo.name = data.companyInfo.logistiCompanyName
						this.baseInfo.parkCode = data.companyInfo.parkCode
						this.baseInfo.contactUsername = data.companyInfo.contactUsername
						this.baseInfo.contactPhone = data.companyInfo.contactPhone
						this.baseInfo.companyAddress = data.companyInfo.companyAddress
						this.baseInfo.logisticCompanyLabel = data.companyInfo.logisticCompanyLabel.split(",")
						this.baseInfo.companyImgUrl1 = data.companyInfo.companyImgUrl1
						this.baseInfo.logisticCompanyLogo = data.companyInfo.logisticCompanyLogo
						this.baseInfo.logisticsName = data.companyInfo.parkName
					}
					
					if(data.organizationInfo){
						//初始化网点信息
						this.netInfo = []
						data.organizationInfo.forEach( item => {
								let netInfoForm = {}
								netInfoForm.id = item.id
								netInfoForm.appNodeName = item.appNodeName
								netInfoForm.companyId = data.companyInfo.id
								netInfoForm.nodeName = item.nodeName
								netInfoForm.cityAll = item.provinceName + item.cityName + item.areaName
								netInfoForm.nodeDutyOfficer = item.nodeDutyOfficer
								netInfoForm.chargerPhone = item.chargerPhone
								netInfoForm.nodeAddress = item.nodeAddress
								netInfoForm.radiationNodeName = item.radiationNodeName
								netInfoForm.provinceName = item.provinceName
								netInfoForm.cityName = item.cityName
								netInfoForm.areaName = item.areaName
								if(item.nodeType){
									netInfoForm.nodeType = item.nodeType
								}else{
									netInfoForm.nodeType = "YYWD"
								}
								this.netInfo.push(netInfoForm)
						})
					}
				},
        error => {
        	Toast(error)
        }
      )
    },
    //初始化路线
    getTmpRouteLines (companyId) {
    	this.$post(GET_TMP_ROUTE_LINES,
				{
					companyId:companyId
				},
				data => {
					this.pathInfo = data
					this.getCompanyOrangization(companyId)
				},
        error => {
        	Toast(error)
        }
      )
    },
    //遍历显示起始地卸货地名字
     getCompanyOrangization (companyId) {
    	this.$get(GET_COMPANY_TMP_ORANGIZATIONS,
				{
					companyId:companyId,
					timeRandom:Math.random()
				},
				data => {
					this.pathInfo = JSON.parse(JSON.stringify(this.pathInfo))
					for( var i = 0 ; i < this.pathInfo.length ; i++){
						for( var k = 0 ; k < data.length ; k++ ){
							if(this.pathInfo[i].startOrganizationId == data[k].id){
								this.pathInfo[i].startOrganizationName = data[k].nodeName
								this.pathInfo[i].startContactUserName = data[k].nodeOfficerName
								this.pathInfo[i].startContactPhoneNo = data[k].nodeOfficerPhone
								this.pathInfo[i].startNodeAddr = data[k].nodeAddress
							}
							if(this.pathInfo[i].destOrganizationId == data[k].id){
								this.pathInfo[i].destOrganizationName = data[k].nodeName
								this.pathInfo[i].destContactUserName = data[k].nodeOfficerName
								this.pathInfo[i].destContactPhoneNo = data[k].nodeOfficerPhone
								this.pathInfo[i].destNodeAddr = data[k].nodeAddress
							}
						}
					}
						
				},
        error => {
        	Toast(error)
        }
      )
    }
  },
  components: {
    uploadImg
  },
  mounted () {
		this.initInfo ()
  }
};
</script>
<style lang="scss" scoped>
.header{
  padding: 0 .2rem;
  font-size: .48rem;
  text-align: center;
  line-height:1.2rem;
  font-size:0.55rem;
  color:#000000;
  .fa-angle-left{
		font-size:0.8rem;
		position: absolute;
		left:0.4rem;
		top:0.3rem;
		color:#999999;
	}
}
.line-box{
	width:100%;
	height:0.2rem;
	background-color: #EEEEEE;
}
.body {
  padding:.2rem 0;
  box-sizing: border-box;
  input::-webkit-input-placeholder {
    color: rgba(204, 204, 204, 1);
  }
  .infoContainer {
  	position: relative;
  	padding:0 0.8rem;
    /*padding-left: 20px;*/
    font-size: 15px;
    .mask{
	  	position: absolute;
	  	width:100%;
	  	height:100%;
	  	top:0;
	  	left:0;
	  	z-index:400;
	  	opacity: 0;
	  }
    .infoItem {
      list-style: disc;
      color: #5989d6;
      margin-bottom: 30px;
      .title {
        font-weight: 600;
        color: rgba(74, 74, 74, 1);
      }
      .inputVal {
      	width:4.6rem;
        float: right;
        text-align: right;
        border: none;
        background: none;
      }
      font{
      	float: right;
      	color:#000000;
      	width:4.6rem;
      	text-align: right;
      }
      .line-type{
      	margin-right:0.2rem;
      }
    }
    .tagsSelector {
      margin: 24px 0;
      ul {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        li {
          min-width: 66px;
          margin: 8px 0;
          box-sizing: border-box;
          padding: 0 10px;
          height: 28px;
          line-height: 28px;
          border-radius: 14px;
          text-align: center;
          color: #9ea6b8;
          border: 1px solid #e2e8f6;
        }
        .selected {
          background: rgba(89, 137, 214, 1);
          color: white;
        }
      }
    }
    .uploadImgBox {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      text-align: center;
      .uploadImg {
        position: relative;
        width: 142px;
        height: 142px;
        border-radius: 6px;
        border: 1px dashed rgba(151, 151, 151, 1);
        display: inline-block;
        margin-top: 12px;
      }
      .center {
        position: absolute;
        top: 34%;
        left: 50%;
        transform: translateX(-50%);
      }
      .title {
        font-weight: 600;
        color: rgba(74, 74, 74, 1);
        margin-bottom: 4px;
        white-space: nowrap;
      }
      .note {
        font-size: 12px;
        color: rgba(255, 82, 82, 1);
      }
    }
  }
  .bigTitle {
    font-size: 18px;
    font-weight: 600;
    color: rgba(89, 137, 214, 1);
    margin: 19px 0;
    position: relative;
    button{
    	position: absolute;
    	right:0;
    	top:0;
    	width:1.5rem;
    	line-height:0.6rem;
    	border-radius: 0.3rem;
    	border:none;
    	outline: none;
    	background-color: rgba(173, 195, 232, 1);
    	color::#FFFFFF;
    	font-size:14px;
    }
    button:active{
    	background-color: rgba(89, 137, 214, 1);
    }
  }
  .addNetBt {
    margin: 0.4rem;
    border: 1px dashed rgba(89, 137, 214, 1);
    height: 42px;
    display: flex;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: rgba(89, 137, 214, 1);
    .icon {
      font-size: 16px;
      margin: 0 8px;
    }
  }
}

.nextStep,
.confirm {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: rgba(89, 137, 214, 1);
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.fade-enter-active,.fade-leave-active {
	transition: opacity .6s;
}

.fade-enter,.fade-leave-to{
	opacity: 0;
}
</style>

